<template>
  <div class="ov-page">
    <div class="ov-header">
      <div class="ov-note ov-note--info ov-header__note">
        <v-icon small>mdi-information-outline</v-icon>
        <span>{{ $t('permission.subtitle') }}</span>
      </div>
    </div>

    <PermissionList
      :permissions="permissionList"
      :loading="loading"
      :load-error="loadError"
      @update-permissions="getPermissionsAvailables"
    />
  </div>
</template>

<script>
import { getPermissionApi } from "../services/permissionApi";
import PermissionList from "../widgets/PermissionList.vue";

export default {
  name: "PermissionUser",

  components: {
    PermissionList,
  },

  data() {
    return {
      permissionList: [],
      loading: false,
      loadError: null,
    };
  },

  methods: {
    // RECUPERER LA LISTE DES FONCTIONNALITÉS DISPONIBLES
    async getPermissionsAvailables() {
      this.loading = true;
      this.loadError = null;
      try {
        this.permissionList = await getPermissionApi({}, this.$store.state.userAuthentified.token);
      } catch (e) {
        this.loadError = e.message;
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.getPermissionsAvailables();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/admin/ui";
</style>
